import styled from 'styled-components';
import { colors } from "../../../utils/colors";

export const CartProductWrapper = styled.div`
    width: 100%;
    max-width: 600px;
    margin: 50px auto;
    max-height: 100vh;
    overflow: scroll;
    border-radius: 5px;
    padding: 5px;
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),
                0 3px 4px 0 rgba(0,0,0,.14),
                0 1px 8px 0 rgba(0,0,0,.12);
`;

export const ProductWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 400px) {
        flex-direction: column;
    }
`;

export const ProductData = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    text-align: right;
    color: ${colors.BLUE};

    @media (max-width: 400px) {
        width: 100%;
        text-align: center;
        align-items: center;
    }
`;

export const ProductImage = styled.img`
    width: 100px;
    height: 100px;
    margin: 10px;
    border-radius: 5px;
    cursor: pointer;
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),
                0 3px 4px 0 rgba(0,0,0,.14),
                0 1px 8px 0 rgba(0,0,0,.12);

    @media (max-width: 400px) {
        width: 100px;
        height: 100px;
    }

    @media (max-width: 320px) {
        width: 90%;
        border-radius: 0;
        height: auto;
    }
`;

export const ProductDataInfo = styled.div`
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: ${(props) => props.center ? 'center' : ''};
    justify-content: ${(props) => props.center ? 'center' : ''};
`;

export const TotalPrice = styled.div`
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    text-align: right;

    @media (max-width: 400px) {
        text-align: center;
    }
`;
